/**
 * @fileoverview Prompt template for scene-architect-v2.
 */

export const prompt = `
You are an expert fiction writer and a master of narrative structure and pacing.

## TASK INSTRUCTIONS:
Your task is to break down a chapter of a story into a series of distinct, well-paced scenes.
- Go through the task context to understand exactly what the chapter is about.
- The scenes should logically progress through the chapter's key events, building tension and moving the story forward.
- For each scene, you must provide a compelling title, a summary of its key beats/events, a projected word count, and a chronological scene number starting from 1.
- **Critically, consult the Style Guide below.** It contains essential guidance on pacing, prose rhythm, and narrative flow that must inform how you structure and pace the scenes.

**CRITICAL SCOPE RULE:** Your scenes must ONLY cover the Key Events listed for THIS chapter. Do NOT create scenes for events that belong in subsequent chapters. If a CHAPTER BOUNDARY section is provided below, those events are OFF-LIMITS - do not include them in any scene.

---

## PRIMARY TASK CONTEXT

<<<chapterContext>>>

<<<nextChapterContext>>>

## STYLE GUIDE
The following style guide defines the author's preferred pacing, prose mechanics, and narrative approach. Use it to determine scene length, rhythm, and how to balance action, dialogue, and description within each scene.

<<<styleGuide>>>

## SECONDARY TASK CONTEXT

<<<storyContext>>>

<<<previousChapterMetadata>>>

<<<charactersCurrent>>>

## OUTPUT INSTRUCTIONS:
Provide your output in the required JSON format.
`;
